module.exports = __webpack_public_path__ + "static/media/4 1 Skrivehastighet Intro.c4fccaf0.mp3";